import React from "react";
import "assets/css/safexpay-web.css";
import "./Registration.css";
import Spinner from "reactstrap/lib/Spinner";
import { base_url } from "assets/utils/const";
import { emailValidation } from "assets/utils/constFuntion";

class ForgotPassword extends React.Component {
  state = {
    isLoaded: false,
    isValidEmail: true,
    email: "",
    userNotValid: false,
    moreThanOneReg: false,
    authToken: localStorage.getItem("Authtoken"),
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (!this.handleEmail()) {
      return false;
    }
    this.setState({
      isLoaded: true,
      userNotValid: false,
      moreThanOneReg: false,
    });
    fetch(`${base_url}api/merchantForgotPassword`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        auth: this.state.authToken,
      },
      body: JSON.stringify({
        ag_id: "paygate",
        user_id: event.target.txtUsername.value,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            localStorage.clear();
            window.location.href = "/signuplogin";
          } else {
            if (result.payLoad === "User does not exist") {
              this.setState({ userNotValid: true });
            }
            if (
              result.payLoad ===
              "Email id mapped with multiple user ids. Please contact support team care@safexpay.com."
            ) {
              this.setState({ moreThanOneReg: true });
            }
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          alert("Failed");
        }
      );
  };
  handleEmail = () => {
    if (
      emailValidation(this.state.email.trim()) &&
      this.state.email &&
      this.state.email.length < 65
    ) {
      let sp = this.state.email.split("@")[1].split(".");
      if (sp.length > 3) {
        document.getElementById("txtUsername").classList.add("is-invalid");
        this.setState({ isValidEmail: false });
        return false;
      } else {
        document.getElementById("txtUsername").classList.remove("is-invalid");
        this.setState({ isValidEmail: true });
        return true;
      }
    } else {
      document.getElementById("txtUsername").classList.add("is-invalid");
      this.setState({ isValidEmail: false });
      return false;
    }
  };
  render() {
    return (
      <>
        <section className="dv-Registration-content dv-forgot-password">
          <div className="container">
            <div className="row">
              <div
                className="col-md-6 dv-instruction"
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                <h1 className="section-heading">Sign Up &amp; Get Started</h1>
                <ul className="tick">
                  <li>Easily accept payments from your customers.</li>
                  <li>Streamline payments to your vendors or partners.</li>
                  <li>Create your own payments or banking platform.</li>
                </ul>
              </div>
              <div
                className="col-md-6 form-div"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <form
                  onSubmit={this.handleSubmit}
                  className="dv-login-form dv-form"
                >
                  <h1 className="section-heading border-heading">
                    Forgot Password
                  </h1>
                  <p className="text-center mx-note color-lightblue mb-3">
                    Kindly check your registered email for Username &amp;
                    Temporary Password.
                  </p>
                  <div className="form-group mx-5">
                    <label htmlFor="txtUsername">Email</label>
                    <input
                      type="text"
                      className="form-control"
                      name="txtUsername"
                      id="txtUsername"
                      placeholder="Enter Email"
                      value={this.state.email}
                      onChange={(e) => this.setState({ email: e.target.value })}
                      onBlur={this.handleEmail}
                    />
                    {!this.state.isValidEmail && (
                      <small className="err">Please Enter a valid email</small>
                    )}
                    {this.state.userNotValid && (
                      <small className="err">*User does not exist.</small>
                    )}
                    {this.state.moreThanOneReg && (
                      <small className="err">
                        *Email id mapped with multiple user ids. Please contact
                        support team care@safexpay.com.
                      </small>
                    )}
                  </div>

                  {/* <p className="text-center">
                                        <a href="/" className="btn btn-forgtpass btn-link">Forgot password</a>
                                    </p> */}
                  <div className="btn-holder mt-5 text-center">
                    <button
                      type="submit"
                      className={
                        this.state.isLoaded
                          ? `btn btn-next btn-gradient disable-btn`
                          : `btn btn-next btn-gradient`
                      }
                      disabled={this.state.isLoaded}
                    >
                      Forgot Password
                      {this.state.isLoaded ? (
                        <Spinner
                          size="sm"
                          color="light"
                          className="btn-loader"
                        />
                      ) : null}
                    </button>
                  </div>

                  <div className="dv-bottom-bg mt-5">
                    <div className="dv-help">
                      Need help?{" "}
                      <a href="/support" className="lnk-contact text-underline">
                        SUPPORT
                      </a>
                    </div>
                    <div className="first-bottom-bg"></div>
                    <div className="second-bottom-bg"></div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default ForgotPassword;
